var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.167 9.5013V17.8346H2.83366V9.5013M9.50033 17.8346V5.33464M9.50033 5.33464H5.75033C5.19779 5.33464 4.66789 5.11514 4.27719 4.72444C3.88649 4.33374 3.66699 3.80384 3.66699 3.2513C3.66699 2.69877 3.88649 2.16886 4.27719 1.77816C4.66789 1.38746 5.19779 1.16797 5.75033 1.16797C8.66699 1.16797 9.50033 5.33464 9.50033 5.33464ZM9.50033 5.33464H13.2503C13.8029 5.33464 14.3328 5.11514 14.7235 4.72444C15.1142 4.33374 15.3337 3.80384 15.3337 3.2513C15.3337 2.69877 15.1142 2.16886 14.7235 1.77816C14.3328 1.38746 13.8029 1.16797 13.2503 1.16797C10.3337 1.16797 9.50033 5.33464 9.50033 5.33464ZM1.16699 5.33464H17.8337V9.5013H1.16699V5.33464Z",
    stroke: "#646D8A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.35e3b0739affad938b93bb2530653bb9.svg";
export { ForwardRef as ReactComponent };